<template>
    <el-row>
        <el-row class="c_margin_top">
            <p>您对此次分离操作是否满意？</p>
            <el-radio-group v-model="textSet.text1">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
            </el-radio-group>
        </el-row>

        <el-row class="c_margin_top">
            <p>补充：针对此次分离操作，您觉得哪些方面可以进一步优化？</p>
            <el-col :span="16">
                <el-input type="textarea" v-model="textSet.text2" maxlength="300"></el-input>
            </el-col>
        </el-row>

    </el-row>
</template>

<script>
    import {mapActions} from 'vuex'
    export default {
        name: "InputComprehensiveEvaluation",
        data() {
            return {
                textSet: {
                    text1: '',
                    text2: '',
                    text3: '',
                    yieldUnit:'',
                },
                unitOpts: [{
                    label: 'g',
                    value: 'g'
                },{
                    label: 'mg',
                    value: 'mg'
                }],
                ...mapActions('sepaMethods',['updateEvaluateSet'])
            }
        },
        methods:{
            resetForm(){
                this.textSet= {
                    text1: '',
                    text2: '',
                    text3: '',
                    yieldUnit:'',
                }
            },
        },
        created() {
          this.textSet = this.$store.state.sepaMethods.EvaluateSet;
        },
        watch : {
            'textSet': {
                handler() {
                    this.updateEvaluateSet(this.textSet)
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    @import '../../../assets/position-adjust.css';
    @import '../../../assets/element-component.css';
</style>